import { useMutation, useQuery, useQueryClient, UseQueryResult } from '@tanstack/react-query';
import { useAuth } from '~/apis/auth';
import { Home } from '~/swagger/Home';
import { HomeProtocolGetNotiCountResponse, HomeProtocolGetProfileResponse } from '~/swagger/data-contracts';
import { http } from './base';

const QueryKey = 'home';

const api = new Home(http);

export const useProfile = (): UseQueryResult<HomeProtocolGetProfileResponse, unknown> => {
  const { data: authData } = useAuth();

  return useQuery([QueryKey, 'profile', authData?.accessToken], async () => {
    const { data } = await api.profileList();
    return data;
  });
};

export const useNoti = (enabled = false): UseQueryResult<HomeProtocolGetNotiCountResponse, unknown> => {
  return useQuery(
    [QueryKey, 'noti'],
    async () => {
      const { data } = await api.notiList();
      return data;
    },
    {
      enabled,
    }
  );
};

export const useProfileMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(api.profileUpdateCreate, {
    onSuccess: () => {
      queryClient.invalidateQueries([QueryKey, 'profile']);
    },
  });
};

export const useCardCreateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(api.profileCardCreate, {
    onSuccess: () => {
      queryClient.invalidateQueries([QueryKey, 'profile']);
    },
  });
};

export const useCardDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(api.profileCardDeleteCreate, {
    onSuccess: () => {
      queryClient.invalidateQueries([QueryKey, 'profile']);
    },
  });
};
